import React, { Fragment } from 'react'

function MobileWidgetItem(props) {
    //console.log('mobile widget ItemInfo: ', props.widgetItemInfo)
    let itemImgUrl = props.widgetItemInfo.Link_Image
    let itemImgAlt = props.widgetItemInfo.Link_Image_Alt
    let itemLink = props.widgetItemInfo.Link_Redirect
    let itemName = props.widgetItemInfo.Link_Name
    let itemNameSuffix = props.widgetItemInfo.Link_Name_Suffix
    //console.log(itemLink)
    return (
        <Fragment>
            <div className="rmt-banner__slide">
                <a href={itemLink} target="_blank" rel="noreferrer">
                    <img className="marg-right-5"
                        src={itemImgUrl}
                        alt={itemImgAlt} />
                    {itemNameSuffix ? <span className="text-graydark-5">{itemName} </span> : <span>{itemName} </span>}
                    {itemNameSuffix ? <span style={{ textDecoration: 'underline' }}>{itemNameSuffix}</span> : null}
                </a>
            </div>
        </Fragment>
    )
}

export default MobileWidgetItem